import React from 'react'
import MatchaSuri from './MatchaSuri'

const App = () => {
  return (
    <div>
      <MatchaSuri/>
    </div>
  )
}

export default App
